// 3rd party
import * as React from 'react';
import { inject } from 'mobx-react';

// Bernie
import { ContextStore } from 'bernie-core';

// Shared UI
import { LocalizedText } from '@shared-ui/localization-context';

// UI Toolkit
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkText } from 'uitk-react-text';

// Components
import { ProductCard } from 'components/products/product-card';

// Models
import { Product } from 'models';

// Stores
import { ProductStore } from 'stores';

interface ToolsProps {
  context?: ContextStore;
  products?: ProductStore;
}

interface ToolsState {
  products: Product[];
}

@inject('context', 'products')
export class Tools extends React.Component<ToolsProps, ToolsState> {
  public constructor(props) {
    super(props);

    this.state = {
      // Hard-coded show off list? Should be parameterised somewhere?
      products: this.props.products.getProducts('us-bex'),
    };
  }

  public render() {
    const { context } = this.props;
    const { products } = this.state;

    const cards = products
      .filter((product) => product.isProduct && product.isEnabled && product.isLive)
      .map((product, i) => (
        <UitkLayoutGridItem key={`product-${i}`}>
          <ProductCard key={product.name} product={product} locale={context.locale} />
        </UitkLayoutGridItem>
      ));

    return (
      <>
        <UitkHeading tag="h2" size={3}>
          <LocalizedText message="home.tools.heading.suite_self_service_tech" />
        </UitkHeading>
        <UitkText spacing="six">
          <UitkText inline={true} weight="bold">
            <LocalizedText message="home.tools.content.join_us_today" />
          </UitkText>{' '}
          <UitkText inline={true}>
            <LocalizedText message="home.tools.content.implemenation_guides_use_cases" />
          </UitkText>
        </UitkText>
        <UitkSpacing padding={{ blockstart: 'six' }}>
          <UitkLayoutGrid columns={{ small: 1, medium: 2, extra_large: 3 }} space="four">
            {cards}
          </UitkLayoutGrid>
        </UitkSpacing>
      </>
    );
  }
}
